<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="item.name"
          :label="$t('qualitycheck.customer.name')"
          type="text"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-model="item.tags"
          :items="customertagSelectItems"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          :label="$t('qualitycheck.customer.tags')"
          item-text="name"
          item-value="@id"
          color="primary"
          chips

          >
          <template v-slot:selection="{ attrs, item, parent, selected }">
            <v-chip
              v-if="item === Object(item)"
              v-bind="attrs"
              color="primary"
              :input-value="selected"
              label
            >
              <span class="pr-2">
                {{ item.name }}
              </span>
            </v-chip>
          </template>
        </v-combobox>
      </v-col>
    </v-row>
    <v-row>
    <v-col cols="12" sm="6" md="6">
      <v-combobox
        v-model="item.distributor"
        :items="distributorSelectItems"
        :no-data-text="$t('global.no_result')"
        :placeholder="$t('global.no_select')"
        clearable
        :label="$t('qualitycheck.distributor.distributors')"
        item-text="name"
        item-value="@id"
      />
    </v-col>
    </v-row>

  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'CustomerFilter',
  props: {
    values: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.customertagGetSelectItems();
    this.distributorGetSelectItems();
  },

  computed: {
    ...mapFields('customertag', {
      customertagSelectItems: 'selectItems',
    }),
    ...mapFields('distributor', {
      distributorSelectItems: 'selectItems',
    }),
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    }
  },
  methods: {
    ...mapActions({
      customertagGetSelectItems: 'customertag/fetchSelectItems',
    }),
    ...mapActions({
      distributorGetSelectItems: 'distributor/fetchSelectItems',
    }),
  }
};
</script>
